<template>
	<div class="standalone-block">
		<div class="subview-block-inner" v-if="loadable" v-html="loadedHtml"></div>
		<div class="subview-block-inner" v-else-if="componentBased"><component :is="resolveSubviewComponent(block.component ?? block.name)" v-bind="componentBinding" :component-name="block.component ?? block.name"></component></div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, watch} from "vue";
import resolveSubviewComponent from "@/router/SubviewResolver.ts";
import {SubviewTab} from "@t/ui/SubView.ts";
import {injectEnv} from "@fd/Environment.ts";

const props = defineProps<{
	block:SubviewTab
}>();
const env = injectEnv();

/** Return true if the content of this subview is loaded from the server */
const loadable = computed<boolean>(() => {
	const at = props.block;
	return at == null ? false : !!at.src;
});
const loadedHtml = ref<string>("");

const componentBased = computed<boolean>(() => {
	const at = props.block;
	return at == null ? false : !!at.component;
});

const componentBinding = computed(() => {
	return props.block?.bind ?? {};
});


watch(() => props.block, (at) => {
	if (loadable.value) {
		loadHtml();
	} else {
		loadedHtml.value = ""
	}
}, { deep: true, immediate: true });

function loadHtml() {
	let ep = props.block.src;
	env.net.fetch(ep).then((resp) => {
		if (resp.ok) {
			resp.text().then((body) => {
				loadedHtml.value = body;
			});
		}
	});
}

</script>

<style>

</style>